// #region Imports
import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import {
  Card,
  Col,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import { estadosFederativosOptions } from "../../constants/estadosFederativos"
import { paisesOptions } from "../../constants/paises"
// #endregion

// #region selectors
import {
  useAuthPermiso,
  useControlEscolarIsLoadingoPersona,
  useControlEscolaroDireccion,
  useAuthIdPersonaAuthenticated,
} from "store/selectors"
// #endregion

// #region actions
import {
  putControlEscolarPutoDireccion as onPutControlEscolarPutoDireccion,
  ControlEscolarUnsetNotificacion,
} from "../../store/actions"
// #endregion

const Direccion = ({ idAlumno, oPersona, isEdit }) => {
  //
  //console.log("oDireccion", oPersona.oDireccion)
  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #endregion

  // #region const-selectors
  const isAdministradorGeneral = useAuthPermiso(["sis_administrador_general"])

  const isLoading = useControlEscolarIsLoadingoPersona()

  const oDireccion = useControlEscolaroDireccion()

  const idPersonaAuthenticated = useAuthIdPersonaAuthenticated()
  // #endregion

  // #region Internal States
  // #endregion

  // #region useEffects
  // useEffect(() => {
  //   console.log("useEffect(() =>")
  //   dispatch(
  //     onGetControlEscolarGetPersona({
  //       nombreSolicitud: "getopersona",
  //       idAlumno: idAlumno,
  //     })
  //   )
  // }, [])
  useEffect(() => {
    //console.log("oPersona", oPersona)
  }, [oPersona])

  useEffect(() => {
    if (oDireccion && oDireccion.id_Direccion > 1) {
      console.log("oDireccion", oDireccion)
      oPersona.oDireccion = oDireccion
    }
  }, [oDireccion, oPersona])

  // #endregion

  // #region Formik form

  const {
    id_Direccion = -1,
    Calle = "",
    Numero_Exterior = "",
    Numero_Interior = "",
    Colonia = "",
    Municipio = "",
    Poblacion = "",
    id_Estado = "",
    id_Pais = "",
    Codigo_Postal = "",
    Apartado_Postal = "",
    Atencion = "",
    Coordenadas_GPS = "",
    Telefono_Fijo = "",
    Telefono_Fijo2 = "",
    Telefono_Fijo3 = "",
    Conmutador = "",
    Extension = "",
    Fax = "",
  } = oPersona?.oDireccion || {}

  const initialValues = {
    id_Direccion,
    Calle,
    Numero_Exterior,
    Numero_Interior,
    Colonia,
    Municipio,
    Poblacion,
    idEstado: id_Estado,
    idPais: id_Pais,
    Codigo_Postal,
    Apartado_Postal,
    Atencion,
    Coordenadas_GPS,
    Telefono_Fijo,
    Telefono_Fijo2,
    Telefono_Fijo3,
    Conmutador,
    Extension,
    Fax,
  }

  const validationSchema = Yup.object({
    Codigo_Postal: Yup.string().matches(
      /^\d{5}$/,
      "El código postal debe tener cinco números."
    ),
    Telefono_Fijo: Yup.string().matches(
      /^\d{10}$/,
      "El teléfono debe tener exactamente 10 dígitos y solo números."
    ),
    Telefono_Fijo2: Yup.string().matches(
      /^\d{10}$/,
      "El teléfono debe tener exactamente 10 dígitos y solo números."
    ),
    Telefono_Fijo3: Yup.string().matches(
      /^\d{10}$/,
      "El teléfono debe tener exactamente 10 dígitos y solo números."
    ),
    idEstado: Yup.number().required("Requerido"),
    idPais: Yup.number().required("Requerido"),
  })

  const onSubmit = values => {
    console.log("Form data", values)
    dispatch(
      onPutControlEscolarPutoDireccion({
        nombreSolicitud: "updatedireccion",
        oDireccion: values,
        idAlumno: idAlumno,
        idPersona: idPersonaAuthenticated,
      })
    )
  }

  const handleUpperCaseChange = event => {
    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const value = event.target.value.toUpperCase()

    // Utiliza Formik para actualizar el valor
    formik.setFieldValue(name, value)
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: onSubmit,
    enableReinitialize: true,
  })
  // #endregion

  return (
    <React.Fragment>
      <Form onSubmit={formik.handleSubmit}>
        {/* Calle, #Exterior, #Interior, Colonia */}
        <Row>
          <Col md={4}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Calle-Input">Calle</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Calle"
                  className="form-control"
                  id="formrow-Calle-Input"
                  placeholder="Calle"
                  value={formik.values.Calle}
                  onChange={handleUpperCaseChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Calle && formik.errors.Calle ? true : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}
              {formik.errors.Calle && formik.touched.Calle ? (
                <FormFeedback type="invalid">
                  {formik.errors.Calle}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col md={2}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Numero_Exterior-Input">
                Número Exterior
              </Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Numero_Exterior"
                  className="form-control"
                  id="formrow-Numero_Exterior-Input"
                  placeholder="#Exterior"
                  value={formik.values.Numero_Exterior}
                  onChange={handleUpperCaseChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Numero_Exterior &&
                    formik.errors.Numero_Exterior
                      ? true
                      : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}
              {formik.errors.Numero_Exterior &&
              formik.touched.Numero_Exterior ? (
                <FormFeedback type="invalid">
                  {formik.errors.Numero_Exterior}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col md={2}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Numero_Interior-Input"># Interior</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Numero_Interior"
                  className="form-control"
                  id="formrow-Numero_Interior-Input"
                  placeholder="Número Interior"
                  value={formik.values.Numero_Interior}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Numero_Interior &&
                    formik.errors.Numero_Interior
                      ? true
                      : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}

              {formik.errors.Numero_Interior &&
              formik.touched.Numero_Interior ? (
                <FormFeedback type="invalid">
                  {formik.errors.Numero_Interior}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col md={4}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Colonia-Input">Colonia</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Colonia"
                  className="form-control"
                  id="formrow-Colonia-Input"
                  placeholder="Colonia"
                  value={formik.values.Colonia}
                  onChange={handleUpperCaseChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Colonia && formik.errors.Colonia
                      ? true
                      : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}

              {formik.errors.Colonia && formik.touched.Colonia ? (
                <FormFeedback type="invalid">
                  {formik.errors.Colonia}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>
        {/* Municipio, Ciudad, Estado, Pais */}
        <Row>
          {/* Municipio */}
          <Col md={3}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Municipio-Input">Municipio</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Municipio"
                  className="form-control"
                  id="formrow-Municipio-Input"
                  placeholder="Municipio"
                  value={formik.values.Municipio}
                  onChange={handleUpperCaseChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Municipio && formik.errors.Municipio
                      ? true
                      : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}

              {formik.errors.Municipio && formik.touched.Municipio ? (
                <FormFeedback type="invalid">
                  {formik.errors.Municipio}
                </FormFeedback>
              ) : null}
            </div>
          </Col>

          {/* Ciudad */}
          <Col md={3}>
            <div className="mb-3">
              <Label htmlFor="formrow-Ciudad-Input">Ciudad / Población</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Ciudad"
                  className="form-control"
                  id="formrow-Ciudad-Input"
                  placeholder="Escribe tu Ciudad"
                  value={formik.values.Ciudad}
                  onChange={handleUpperCaseChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Ciudad && formik.errors.Ciudad ? true : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}

              {formik.errors.Ciudad && formik.touched.Ciudad ? (
                <FormFeedback type="invalid">
                  {formik.errors.Ciudad}
                </FormFeedback>
              ) : null}
            </div>
          </Col>

          {/* Estado */}
          <Col lg={3}>
            <div className="mb-3">
              <Label htmlFor="formrow-InputidEstado">* Estado</Label>
              {!isLoading ? (
                <select
                  name="idEstado"
                  id="formrow-InputidEstado"
                  className="form-control"
                  value={formik.values.idEstado}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {estadosFederativosOptions.map(option => {
                    return (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.idEstado && formik.touched.idEstado ? (
                <span className="text-danger">{formik.errors.idEstado}</span>
              ) : null}
            </div>
          </Col>

          {/* Pais */}
          <Col lg={3}>
            <div className="mb-3">
              <Label htmlFor="formrow-idPais">* País</Label>
              {!isLoading ? (
                <select
                  name="idPais"
                  id="formrow-idPais"
                  className="form-control"
                  value={formik.values.idPais}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value={-1}>Elige...</option>
                  {paisesOptions.map(option => {
                    return (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    )
                  })}
                </select>
              ) : (
                <p aria-hidden="true" className="mt-2">
                  <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                </p>
              )}
              {formik.errors.idPais && formik.touched.idPais ? (
                <FormFeedback type="invalid">
                  {formik.errors.idPais}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>
        {/* Cp, Apartado Postal, Atención, GPS */}
        <Row>
          {/* Código Postal */}
          <Col md={3}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Codigo_Postal-Input">Código Postal</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Codigo_Postal"
                  className="form-control"
                  id="formrow-Codigo_Postal-Input"
                  placeholder="Zip code"
                  value={formik.values.Codigo_Postal}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  autoComplete="off"
                  invalid={
                    formik.touched.Codigo_Postal && formik.errors.Codigo_Postal
                      ? true
                      : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}

              {formik.errors.Codigo_Postal && formik.touched.Codigo_Postal ? (
                <FormFeedback type="invalid">
                  {formik.errors.Telefono_Celular}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          {/* Apartado Postal */}
          <Col md={3}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Apartado_Postal-Input">
                Apartado Postal
              </Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Apartado_Postal"
                  className="form-control"
                  id="formrow-Apartado_Postal-Input"
                  placeholder="Apartado Postal"
                  value={formik.values.Apartado_Postal}
                  onChange={handleUpperCaseChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Apartado_Postal &&
                    formik.errors.Apartado_Postal
                      ? true
                      : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}

              {formik.errors.Apartado_Postal &&
              formik.touched.Apartado_Postal ? (
                <FormFeedback type="invalid">
                  {formik.errors.Apartado_Postal}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          {/* Atención */}
          <Col md={3}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Atencion-Input">Atención</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Atencion"
                  className="form-control"
                  id="formrow-Atencion-Input"
                  placeholder="Atención"
                  value={formik.values.Atencion}
                  onChange={handleUpperCaseChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Atencion && formik.errors.Atencion
                      ? true
                      : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}

              {formik.errors.Atencion && formik.touched.Atencion ? (
                <FormFeedback type="invalid">
                  {formik.errors.Atencion}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          {/* Gps */}
          <Col md={3}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Coordenadas_GPS-Input">
                Coordendas GPS
              </Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Coordenadas_GPS"
                  className="form-control"
                  id="formrow-Coordenadas_GPS-Input"
                  placeholder="Coordenadas GPS"
                  value={formik.values.Coordenadas_GPS}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Coordenadas_GPS &&
                    formik.errors.Coordenadas_GPS
                      ? true
                      : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}

              {formik.errors.Coordenadas_GPS &&
              formik.touched.Coordenadas_GPS ? (
                <FormFeedback type="invalid">
                  {formik.errors.Coordenadas_GPS}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>
        {/* Linea Teléfonos */}
        <Row className="mb-2">
          <Col>
            <h5>Teléfonos.</h5>
          </Col>
        </Row>
        {/* Telefono Fijo, Telefono Fijo2, Telefono Fijo 3 */}
        <Row>
          <Col md={3}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Telefono_Fijo-Input">Teléfono</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Telefono_Fijo"
                  className="form-control"
                  id="formrow-Telefono_Fijo-Input"
                  placeholder="Teléfono"
                  value={formik.values.Telefono_Fijo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Telefono_Fijo && formik.errors.Telefono_Fijo
                      ? true
                      : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}

              {formik.errors.Telefono_Fijo && formik.touched.Telefono_Fijo ? (
                <FormFeedback type="invalid">
                  {formik.errors.Telefono_Fijo}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col md={3}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Telefono_Fijo2-Input">Teléfono 2</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Telefono_Fijo2"
                  className="form-control"
                  id="formrow-Telefono_Fijo2-Input"
                  placeholder="Teléfono"
                  value={formik.values.Telefono_Fijo2}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Telefono_Fijo2 &&
                    formik.errors.Telefono_Fijo2
                      ? true
                      : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}

              {formik.errors.Telefono_Fijo2 && formik.touched.Telefono_Fijo2 ? (
                <FormFeedback type="invalid">
                  {formik.errors.Telefono_Fijo2}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col md={3}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Telefono_Fijo3-Input">Teléfono 3</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Telefono_Fijo3"
                  className="form-control"
                  id="formrow-Telefono_Fijo3-Input"
                  placeholder="Teléfono"
                  value={formik.values.Telefono_Fijo3}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Telefono_Fijo3 &&
                    formik.errors.Telefono_Fijo3
                      ? true
                      : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}

              {formik.errors.Telefono_Fijo3 && formik.touched.Telefono_Fijo3 ? (
                <FormFeedback type="invalid">
                  {formik.errors.Telefono_Fijo3}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>
        {/* Conmutador, Extensión, Fax */}
        <Row>
          <Col md={3}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Conmutador-Input">Conmutador</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Conmutador"
                  className="form-control"
                  id="formrow-Conmutador-Input"
                  placeholder="Conmutador"
                  value={formik.values.Conmutador}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Conmutador && formik.errors.Conmutador
                      ? true
                      : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}

              {formik.errors.Conmutador && formik.touched.Conmutador ? (
                <FormFeedback type="invalid">
                  {formik.errors.Conmutador}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col md={3}>
            {" "}
            <div className="mb-3">
              <Label htmlFor="formrow-Extension-Input">Extensión</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Extension"
                  className="form-control"
                  id="formrow-Extension-Input"
                  placeholder="Extensión"
                  value={formik.values.Extension}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Extension && formik.errors.Extension
                      ? true
                      : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}

              {formik.errors.Extension && formik.touched.Extension ? (
                <FormFeedback type="invalid">
                  {formik.errors.Extension}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col lg={3}>
            <div className="mb-3">
              <Label htmlFor="formrow-Fax">Fax</Label>
              {!isLoading ? (
                <Input
                  type="text"
                  name="Fax"
                  className="form-control"
                  id="formrow-Fax"
                  placeholder="Fax"
                  value={formik.values.Fax}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.Fax && formik.errors.Fax ? true : false
                  }
                />
              ) : (
                <div>
                  <p aria-hidden="true" className="mt-2">
                    <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                  </p>
                </div>
              )}

              {formik.errors.Fax && formik.touched.Fax ? (
                <FormFeedback type="invalid">{formik.errors.Fax}</FormFeedback>
              ) : null}
            </div>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-2">
          {isEdit ? (
            <button
              type="submit"
              className="btn btn-primary w-md"
              disabled={!formik.isValid || !isAdministradorGeneral}
            >
              Enviar
            </button>
          ) : null}
          {/* <button
            type="button"
            className="btn btn-primary"
            onClick={() => setShow(true)}
            id="liveAlertBtn"
          >
            Show live alert
          </button> */}
        </div>
      </Form>
    </React.Fragment>
  )
}

export default Direccion
